export function fromPairs<T>(arr: [string, T][]) {
  const obj: Record<string, T> = {};

  for (const [key, value] of arr) {
    obj[key] = value;
  }
  return obj;
}

type NonNull = string | number | boolean | symbol | bigint | object;
export function compact<T = NonNull>(arr: (T | null | undefined)[]): T[] {
  return arr.filter((it) => it !== null && it !== undefined) as T[];
}

type Arrify<T> = T extends null | undefined ? [] : T extends readonly unknown[] ? T : [T];
export function arrify<T>(arr: T | undefined | null): Arrify<T> {
  if (arr === undefined || arr === null) return <Arrify<T>>[];

  return Array.isArray(arr) ? <Arrify<T>>arr : <Arrify<T>>[arr];
}

type PartitionArrayReturnType<T> = [T[], T[]];
export function partitionArray<T>(
  arr: T[],
  validate: (item: T) => boolean,
): PartitionArrayReturnType<T> {
  return arr.reduce(
    ([left, right]: PartitionArrayReturnType<T>, item: T): PartitionArrayReturnType<T> =>
      validate(item) ? [[...left, item], right] : [left, [...right, item]],
    [[], []],
  );
}

export function areStringArrayContentSimilar(
  array1: (string | undefined)[],
  array2: (string | undefined)[],
) {
  const noDiff1 = array1.filter((i) => !array2.includes(i)).length === 0;
  const noDiff2 = array2.filter((i) => !array1.includes(i)).length === 0;

  return noDiff1 && noDiff2;
}
